export default {
  AUTO_LOANS: 'auto_loans',
  BANKING: 'banking',
  CREDIT_CARDS: 'credit_cards',
  EDUCATION_LOANS: 'education_loans',
  ESTATE_PLANNING: 'estate_planning',
  EXPANSION: 'expansion',
  FTHB_PROGRAMS: 'first_time_home_buyer_programs',
  INSURANCE: 'insurance',
  INVESTING: 'investing',
  MORTGAGES: 'mortgages',
  MOVING: 'moving',
  PERSONAL_LOANS: 'personal_loans',
  SMB_LOANS: 'small_medium_business_loans',
  SOFTWARE: 'software',
  TAXES: 'taxes',
  UTILITIES: 'utilities',
};
